// Generated by `bun run --filter @esi/shared catalogue:sync` (scripts/catalogue-sync.ts):
// do not edit. From @opencode-ai/models@0.0.119, snapshot 2026-10-29T05:26:25.333Z: the
// served labs (a Bedrock profile in a served geography), their Bedrock ID prefixes and families
// with the derived default tier (model-picking D3); overrides live in family-overrides.ts.
// Model metadata from models.dev (https://models.dev), licence in canonical.generated.ts.

export const GENERATED_LABS = {
  anthropic: {
    id: "anthropic",
    displayName: "Anthropic",
    bedrockPrefixes: ["anthropic"],
  },
  amazon: {
    id: "amazon",
    displayName: "Amazon",
    bedrockPrefixes: ["amazon"],
  },
  mistral: {
    id: "mistral",
    displayName: "Mistral",
    bedrockPrefixes: ["mistral"],
  },
  moonshotai: {
    id: "moonshotai",
    displayName: "Moonshot AI",
    bedrockPrefixes: ["moonshotai"],
  },
  openai: {
    id: "openai",
    displayName: "OpenAI",
    bedrockPrefixes: ["openai"],
  },
  xai: {
    id: "xai",
    displayName: "xAI",
    bedrockPrefixes: ["xai"],
  },
  zhipuai: {
    id: "zhipuai",
    displayName: "Zhipu AI",
    bedrockPrefixes: ["zai"],
  },
} as const;

export const GENERATED_FAMILIES = {
  "anthropic/claude-haiku": {
    id: "anthropic/claude-haiku",
    lab: "anthropic",
    displayName: "Claude Haiku",
    tier: "fast",
  },
  "anthropic/claude-sonnet": {
    id: "anthropic/claude-sonnet",
    lab: "anthropic",
    displayName: "Claude Sonnet",
    tier: "balanced",
  },
  "anthropic/claude-opus": {
    id: "anthropic/claude-opus",
    lab: "anthropic",
    displayName: "Claude Opus",
    tier: "deep",
  },
  "anthropic/claude-fable": {
    id: "anthropic/claude-fable",
    lab: "anthropic",
    displayName: "Claude Fable",
    tier: "frontier",
  },
  "amazon/nova-micro": {
    id: "amazon/nova-micro",
    lab: "amazon",
    displayName: "Nova Micro",
    tier: "fast",
  },
  "amazon/nova-lite": {
    id: "amazon/nova-lite",
    lab: "amazon",
    displayName: "Nova Lite",
    tier: "balanced",
  },
  "amazon/nova-pro": {
    id: "amazon/nova-pro",
    lab: "amazon",
    displayName: "Nova Pro",
    tier: "deep",
  },
  "amazon/nova": {
    id: "amazon/nova",
    lab: "amazon",
    displayName: "Nova Lite",
    tier: "other",
  },
  "mistral/pixtral": {
    id: "mistral/pixtral",
    lab: "mistral",
    displayName: "Pixtral Large",
    tier: "balanced",
  },
  "moonshotai/kimi-k3": {
    id: "moonshotai/kimi-k3",
    lab: "moonshotai",
    displayName: "Kimi K3",
    tier: "balanced",
  },
  "openai/gpt-luna": {
    id: "openai/gpt-luna",
    lab: "openai",
    displayName: "GPT Luna",
    tier: "fast",
  },
  "openai/gpt-terra": {
    id: "openai/gpt-terra",
    lab: "openai",
    displayName: "GPT Terra",
    tier: "balanced",
  },
  "openai/gpt-sol": {
    id: "openai/gpt-sol",
    lab: "openai",
    displayName: "GPT Sol",
    tier: "deep",
  },
  "openai/gpt-astra": {
    id: "openai/gpt-astra",
    lab: "openai",
    displayName: "GPT Astra",
    tier: "frontier",
  },
  "xai/grok": {
    id: "xai/grok",
    lab: "xai",
    displayName: "Grok",
    tier: "balanced",
  },
  "zhipuai/glm": {
    id: "zhipuai/glm",
    lab: "zhipuai",
    displayName: "GLM",
    tier: "balanced",
  },
} as const;
